import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {Divider, MenuItem} from '@mui/material';

import {useFileMenuContext} from './fileMenuContext';
import {useFileContext} from 'context/FileContext';
import ConfirmationWrapper from 'components/buttons/ConfirmationWrapper';
import {DELETE_FILE_MSG, DELETE_FOLDER_MSG} from 'const';

const ContextItems = memo(() => {
   const {t} = useTranslation();
   const {data, handleClose} = useFileMenuContext();

   const {
      create: {openRename},
      move: {moveItem},
      downloadEncrypted,
      remove,
   } = useFileContext();

   return (
      <>
         <MenuItem
            onClick={() => {
               openRename(data);
               handleClose();
            }}
         >
            {t('Edit')}
         </MenuItem>
         {data.type === 'file' && (
            <>
               <Divider />
               <MenuItem
                  onClick={() => {
                     downloadEncrypted(data.path);
                     handleClose();
                  }}
               >
                  {t('Download')}
               </MenuItem>
            </>
         )}
         <Divider />
         <MenuItem
            onClick={() => {
               moveItem(data);
               handleClose();
            }}
         >
            {t('Move')}
         </MenuItem>
         <Divider />
         <ConfirmationWrapper
            onOk={() => {
               remove(data);
               handleClose();
            }}
            content={
               t(data.type === 'file' ? DELETE_FILE_MSG : DELETE_FOLDER_MSG) + '\n' + data.name
            }
         >
            <MenuItem>{t('Remove')}</MenuItem>
         </ConfirmationWrapper>
      </>
   );
});

export default ContextItems;
